import { useEffect, useCallback, useState } from "react";
// routes
import { ROUTES } from "@/core/router/routes";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/core/context/AuthContext";
//

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const [firstLoad, setFirstLoad] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(true);

  const check = useCallback(() => {
    if (!isAuthenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname,
      }).toString();

      const loginPath = ROUTES.Auth.SignIn;

      const href = `/${ROUTES.Auth.Root}/${loginPath}?${searchParams}`;

      navigate(href);
    } else {
      setChecked(true);
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (!firstLoad) {
      check();
    } else {
      setFirstLoad(false);
    }
     
  }, [check, firstLoad]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
